import { createTheme } from '@mui/material/styles';
import colors from '../designTokens/colors';
import colorsCustom from '../designTokens/colorsCustom';
import other from '../designTokens/other';

const muiTheme = createTheme({
  palette: {
    primary: {
      // main: colors.gray[9],
      main: colorsCustom.ui.dark.bold,
    },
    secondary: {
      main: colors.gray[7],
    },
    background: {
      default: colorsCustom.background,
      paper: colorsCustom.paper,
    },
    text: {
      primary: colorsCustom.ui.dark.bold,
      secondary: colorsCustom.ui.dark.moderate,
      disabled: colorsCustom.ui.dark.subtle,
    },
  },
  typography: {
    fontFamily: '"SUIT Variable", sans-serif',
    h1: {
      fontSize: '6rem',
      fontWeight: 300,
      lineHeight: 1.167,
    },
    h2: {
      fontSize: '3.75rem',
      fontWeight: 300,
      lineHeight: 1.2,
    },
    h3: {
      fontSize: '3rem',
      fontWeight: 400,
      lineHeight: 1.167,
    },
    h4: {
      fontSize: '2.125rem',
      fontWeight: 400,
      lineHeight: 1.235,
    },
    h5: {
      fontSize: '1.5rem',
      fontWeight: 400,
      lineHeight: 1.334,
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.5,
      fontWeight: 500,
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.43,
      fontWeight: 500,
    },
    caption: {
      fontSize: '0.75rem',
      lineHeight: 1.33,
      fontWeight: 500,
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 768,
      md: 1024,
      lg: 1184,
      xl: 1440,
    },
  },
  spacing: 8,
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
          boxShadow: 'none',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: 'none',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
        },
      },
    },
    MuiFab: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          boxShadow: 'none',
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          boxShadow: 'none',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
        },
      },
    },
  },
  // Custom design tokens
  customTokens: {
    sizes: other.size,
    colors: {
      ...colors,
      custom: colorsCustom,
    },
  },
});

export default muiTheme;